import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a4378c7")

_pushScopeId("data-v-3a4378c7")
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "昵称", -1)
const _hoisted_5 = { class: "form-item-label" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "性别", -1)
const _hoisted_8 = { class: "form-item-label" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "手机号", -1)
const _hoisted_11 = { class: "form-item-label" }
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "上牌地点", -1)
const _hoisted_14 = { class: "form-item-label" }
const _hoisted_15 = { class: "form-item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, "购车时间", -1)
const _hoisted_17 = { class: "form-item-label" }
const _hoisted_18 = {
  key: 0,
  class: "form-item"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "form-item-label label-witdh" }, "购车预算", -1)
const _hoisted_20 = { class: "form-item-label" }
const _hoisted_21 = {
  key: 1,
  class: "form-item"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "form-item-label label-witdh" }, "意向车型", -1)
const _hoisted_23 = { class: "intention-car" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, _toDisplayString($props.inquiryInfoClientVO.nickName || "--"), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, _toDisplayString($setup.genderName($props.inquiryInfoClientVO.gender)), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, _toDisplayString($props.inquiryInfoClientVO.mobile), 1)
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, _toDisplayString($props.inquiryInfoClientVO.cityName), 1)
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode("div", _hoisted_17, _toDisplayString($props.inquiryInfoClientVO.purchaseTimeName), 1)
      ]),
      ($props.inquiryInfoClientVO.purchaseBudgets)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, _toDisplayString($props.inquiryInfoClientVO.purchaseBudgets), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, _toDisplayString($props.inquiryInfoClientVO.intendedModelName), 1)
          ]))
    ])
  ]))
})